import moment from "moment";
import NumeroALetras from "../../../../componentes/funciones/NumeroALetras";
import { generarPDF } from "../../../../componentes/imprimir/GenerarPDF";
import { ImprimirEnIframe } from "../../../../componentes/imprimir/ImprimirEnIframe";
import { NegocioConfig } from "../../../../configuracion/Empresa";
import { formatoMoneda } from "../../../../configuracion/validaciones";
import { generarImagenes } from "../../../../componentes/imprimir/GenerarImagenes";

export const ImprimirPedido = (pedido) => {
  if (!pedido) return;

  const {
    id,
    Cliente,
    Empleado,
    cliente,
    empleado,
    detalles = [],
    direcciones = [],
    fecha,
    subtotal = 0,
    isv = 0,
    total = 0,
    notaNueva,
  } = pedido;

  const ClienteObj = Cliente || cliente;
  const EmpleadoObj = Empleado || empleado;

  const items = detalles;

  const clienteNombreCompleto = ClienteObj?.nombreCorto || ClienteObj?.nombreCompleto || 'Consumidor Final';
  const empresaNombre = ClienteObj?.ClienteEmpresas?.[0]?.nombre;
  const empresaRtn = ClienteObj?.ClienteEmpresas?.[0]?.rtn;

  const rtnAImprimir = ClienteObj?.rtn || empresaRtn || "";
  let nombreAImprimir = clienteNombreCompleto;

  if (rtnAImprimir && rtnAImprimir === empresaRtn && empresaNombre && empresaNombre !== "") {
    nombreAImprimir = empresaNombre;
  }

  const empleadoNombre = EmpleadoObj?.nombreCorto || EmpleadoObj?.nombreCompleto || 'N/A';

  const fechaHora = moment(fecha || new Date()).format("DD-MM-YYYY HH:mm:ss");
  const direccion = direcciones[0]?.direccion || "No especificada";

  const tipoDocumento = "ORDEN DE PEDIDO";
  const numeroDocumento = String(id || "—");

  const html = `
      <div style="width:280px; font-family:'Arial', sans-serif; font-size:14px; color:black; padding:0; margin:0;">
          <img src=${NegocioConfig.logo} style="width:150px; height:100px; display:block; margin:0 auto; padding:0; border:0;" alt="Logo" />
        <div style="text-align:center; margin-bottom:5px;">
            <div style="font-weight:bold; font-size:16px;">${NegocioConfig.nombre}</div>
          <div style="font-size: 12px;">
            RTN: ${NegocioConfig.rtn}
          </div>
          <div style="font-size: 12px;">
            ${NegocioConfig.direccion}
          </div>
          <div style="font-size: 12px;">
            Tel: ${NegocioConfig.telefono}
          </div>
        <div style="font-weight:bold; margin:5px 0; text-align: left;">${tipoDocumento} No. ${numeroDocumento}</div>
        <div style="text-align: left;"><span>Fecha:</span> ${fechaHora}</div>
        <div style="text-align: left;"><span>Atendió:</span> ${empleadoNombre}</div>
      </div>
      <hr style="border:1px dashed black;" />
        <div><strong>Cliente:</strong> ${nombreAImprimir}</div>
        <div><strong>RTN:</strong> ${rtnAImprimir || 'N/A'}</div> 
        <div><strong>Dirección:</strong> ${direccion}</div> 
        <hr style="border:1px dashed black;" />

        <div style="margin-top:5px;">
          ${items.map((item) => {
            const nombre = item.producto?.nombre || item.servicio?.nombre || "—";
            const codigo = item.producto?.codigo || item.servicio?.codigo || "—";
            const cantidad = parseFloat(item.cantidad || 0);
            const precioUnitario = parseFloat(item.precio || 0);
            const subtotalMostrado = cantidad * precioUnitario;

            return `
              <div style="margin-bottom:5px;">
                <div style="font-size:11px; margin-bottom:2px;">
                  ${codigo}
                </div>
                <div style="font-weight:bold; font-size:13px;">${nombre}</div>
                <div style="display:flex; justify-content:space-between; font-size:12px;">
                  <span>${cantidad} x ${formatoMoneda(precioUnitario)}</span>
                  <span style="font-weight:bold;">${formatoMoneda(subtotalMostrado)}</span>
                </div>
              </div>`;
          }).join("")}
        </div>
        <hr style="border:1px dashed black;" />
        
        <div style="text-align:right;">
          <div>Subtotal Ítems: <strong>${formatoMoneda(subtotal)}</strong></div>
          <div>ISV: <strong>${formatoMoneda(isv)}</strong></div>
              
          <div style="font-size:14px; font-weight:bold;">Total a Pagar: ${formatoMoneda(total)}</div>
          <div style="margin-top:4px; margin-bottom:8px; font-weight:bold; font-size:12px; text-transform:uppercase;">
            ${NumeroALetras(total)}
          </div>
        </div>

        ${notaNueva && notaNueva.trim() !== "" ? `
            <hr style="border:1px dashed black;" />
            <div style="margin-top: 10px; font-size: 12px; text-align: left;">
                <strong>Notas del Pedido:</strong>
                <div style="margin-top: 3px; font-size: 11px;">${notaNueva}</div>
            </div>
        ` : ''}

      <div style="text-align:center; margin-top:20px; font-size:14px;">
        <strong>¡Gracias por su pedido!</strong>
      </div>
    </div>
    `;

  const nombreBase = `Comprobante_Pedido_${numeroDocumento}`;
  const nombrePDF = `${nombreBase}.pdf`;

  ImprimirEnIframe(html, `Comprobante de Pedido ${numeroDocumento}`, '5px');
  generarImagenes(html, 'Comprobante de Pedido', numeroDocumento, 70);
  //generarPDF(html, nombrePDF, 70);
};